import {
  getOfferByCategory,
  getOffersByCategory,
  Offer,
  OffersByCategory,
  StrictOffersMapByCategory,
} from 'core/offers/entities';

export const mapOffersByCategoryToOffersMap = (
  offers: Offer[],
  categories: OffersByCategory,
): StrictOffersMapByCategory => {
  const {
    defaultOffers,
    timeUpOffers,
    discountDefaultOffers,
    discountOffer,
    numerologyAnalysisUpsell,
    tarotReadingUpsell,
    palmistryGuideUpsell,
    ultraPackUpsell,
    trialCreditsUpsell,
    premiumUpsell,
    natalChartUpsell,
    blackMoonUpsell,
    discountNumerologyAnalysisUpsell,
    discountUltraPackUpsell,
    discountPalmistryUpsell,
    discountTarotReadingUpsell,
    consultationUpsell,
    discountConsultationUpsell,
    readingsPackUpsellOffer,
  } = categories;

  return {
    defaultOffers: getOffersByCategory(offers, defaultOffers),
    timeUpOffers: getOffersByCategory(offers, timeUpOffers),
    discountDefaultOffers: getOffersByCategory(offers, discountDefaultOffers),
    discountOffer: getOfferByCategory(offers, discountOffer),
    numerologyAnalysisUpsell: getOfferByCategory(offers, numerologyAnalysisUpsell),
    tarotReadingUpsell: getOfferByCategory(offers, tarotReadingUpsell),
    palmistryGuideUpsell: getOfferByCategory(offers, palmistryGuideUpsell),
    ultraPackUpsell: getOfferByCategory(offers, ultraPackUpsell),
    discountUltraPackUpsell: getOfferByCategory(offers, discountUltraPackUpsell),
    trialCreditsUpsell: getOfferByCategory(offers, trialCreditsUpsell),
    premiumUpsell: getOfferByCategory(offers, premiumUpsell),
    natalChartUpsell: getOfferByCategory(offers, natalChartUpsell),
    blackMoonUpsell: getOfferByCategory(offers, blackMoonUpsell),
    discountNumerologyAnalysisUpsell: getOfferByCategory(offers, discountNumerologyAnalysisUpsell),
    discountPalmistryUpsell: getOfferByCategory(offers, discountPalmistryUpsell),
    discountTarotReadingUpsell: getOfferByCategory(offers, discountTarotReadingUpsell),
    consultationUpsell: getOfferByCategory(offers, consultationUpsell),
    discountConsultationUpsell: getOfferByCategory(offers, discountConsultationUpsell),
    readingsPackUpsellOffer: getOfferByCategory(offers, readingsPackUpsellOffer),
  };
};
